export default "__VITE_ASSET__3bf28469__"